export const SET_RECOMMENDATIONS = 'setRecommendations';
export const SET_PANEL_LOADED_STATE = 'setPanelLoadedState';
export const SET_WISHLIST_LOADED = 'setWishlistLoaded';
export const SET_PAGE_ID = 'setPageId';
